import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import ServiceList from "../../components/admincomponents/ServiceList";

function Services({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <ServiceList  />            
    </>
  );
}

export default Services;
